import { useState } from 'react';
import { images } from '../../constants';
import { AppWrap, MotionWrap } from '../../wrapper';
import './Footer.scss';

const Footer = () => {
  const [formData, setFormData] = useState({ username: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const response = await fetch(process.env.REACT_APP_FORMSPREE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: formData.username,
        email: formData.email,
        message: formData.message,
      }),
    });

    setLoading(false);

    if (response.ok) {
      setIsFormSubmitted(true);
    } else {
      alert('Something went wrong. Please try again later.');
    }
  };

  return (
    <section className="mx-auto w-full max-w-5xl px-5 py-12 sm:px-8 sm:py-16 lg:px-12 lg:py-20">
      <div className="max-w-[64ch]">
        <p className="mb-3 text-[0.85rem] uppercase tracking-[0.12em] text-black/60">
          Contact
        </p>
        <h2 className="text-3xl font-semibold tracking-[-0.02em] text-black/90 sm:text-4xl">
          Message me
        </h2>
      </div>

      {/* contact cards */}
      <div className="mt-8 grid gap-3 sm:grid-cols-2">
        <a
          href="mailto:reynaldodomenico@gmail.com"
          className="flex items-center gap-3 rounded-2xl border border-black/10 bg-white/60 p-4 transition hover:border-black/20"
        >
          <img src={images.email} alt="" className="h-5 w-5 opacity-80" />
          <span className="text-sm text-black/80">reynaldodomenico@gmail.com</span>
        </a>

        <a
          href="tel:+4917674284786"
          className="flex items-center gap-3 rounded-2xl border border-black/10 bg-white/60 p-4 transition hover:border-black/20"
        >
          <img src={images.mobile} alt="" className="h-5 w-5 opacity-80" />
          <span className="text-sm text-black/80">+49 176 7428 4786</span>
        </a>
      </div>

      {!isFormSubmitted ? (
        <form onSubmit={handleSubmit} className="mt-8 grid gap-3">
          <input
            className="w-full rounded-2xl border border-black/10 bg-white/60 px-4 py-3 text-sm text-black/90 outline-none placeholder:text-black/40 focus:border-black/20"
            type="text"
            placeholder="Your name"
            name="username"
            value={username}
            onChange={handleChangeInput}
            required
          />

          <input
            className="w-full rounded-2xl border border-black/10 bg-white/60 px-4 py-3 text-sm text-black/90 outline-none placeholder:text-black/40 focus:border-black/20"
            type="email"
            placeholder="Your email"
            name="email"
            value={email}
            onChange={handleChangeInput}
            required
          />

          <textarea
            className="min-h-[140px] w-full rounded-2xl border border-black/10 bg-white/60 px-4 py-3 text-sm leading-relaxed text-black/90 outline-none placeholder:text-black/40 focus:border-black/20"
            placeholder="Your message"
            value={message}
            name="message"
            onChange={handleChangeInput}
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="w-fit rounded-full bg-black/90 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-black disabled:opacity-50"
          >
            {!loading ? 'Send message' : 'Sending...'}
          </button>
        </form>
      ) : (
        <div className="mt-10 max-w-[64ch]">
          <h3 className="text-2xl font-semibold tracking-[-0.02em] text-black/90">
            Thanks for reaching out.
          </h3>
          <p className="mt-2 text-sm leading-relaxed text-black/75">
            I will get back to you soon.
          </p>
        </div>
      )}
    </section>
  );
};

export default AppWrap(MotionWrap(Footer, 'app__footer'), 'contact', 'app__whitebg');